import React, { useEffect, useRef, useState } from "react"
import { createPortal } from "react-dom"
import styled from "styled-components"
import { device, IconSvg, LimitCharacters, Main_Plain } from "monica-alexandria"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import NoImg from "../../assets/NoImage.png"
import { ReactComponent as IntegrationsIcon } from "../../assets/Integrations.svg"
import { useCRMContext } from "../../context/CrmContext"
import b from "../../services/api/Boards"
import { open_email_marketing } from "../../pages/integrations/emailMarketingNavigation";
import { getBoardAvatarSrc } from '../../utils/boardAvatar';

let minioImgUrl = process.env.REACT_APP_MINIO_PROTOCOL +
    process.env.REACT_APP_MINIO_HOST + 
    process.env.REACT_APP_MINIO_PORT+ '/' +
    process.env.REACT_APP_MINIO_DAILYPROFIT_BUCKET ;

const TooltipPortal = styled.div`
    position: fixed;
    border: ${p => p.theme.mid} 1px solid;
    transform: translateY(-50%);
    background: ${p => p.theme.mid};
    color: ${p => p.theme.color};
    padding: var(--smallPads);
    border-radius: var(--smallRadius);
    white-space: nowrap;
    pointer-events: none;
    transition: opacity .3s, transform .3s;
    font-family: "fontBold";
    font-size: 1.2rem;
    z-index: 9999;
`

const SidebarQuests = styled.div`
    padding-bottom: 4rem;
    .MainPlain{
        margin: 0 auto;
        display: ${p => p.sidebar ? "block" : "none"};
    }
    
`

const SidebarQuestsList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;

    
`

const SidebarQuestsItem = styled.li`
    display: flex;
    gap: 1rem;
    align-items: center;
    padding: .5rem;
    padding-left: ${p => p.expand ? "4rem" : "1rem"};
    cursor: pointer;
    background: ${p => p.active ? p.theme.mid : "transparent"};
    position: relative;
    justify-content: ${p => p.expand ? "left" : "center"};

    img{
        width: 3rem;
        height: 3rem;
        /* overflow: hidden; */
        border-radius: var(--smallRadius);
        object-fit: cover;
    }

    svg{
        width: 1.8rem;
        fill: ${p => p.theme.color};
    }

    p{
        font-size: 1.5rem;
        display: ${p => p.expand ? "block" : "none"};
    }

    h5{
        display: ${p => p.expand ? "block" : "none"};
    }

    &:hover{
        background: ${p => p.theme.low};
    }

    @media ${device.sm} {
        /* padding-left: 2rem; */

        img{
            width: 3.5rem;
            height: 3.5rem;
        }
    }
`

const SidebarIntegrationItem = styled(SidebarQuestsItem)`
    svg {
        width: 3rem;
    }

    img {
        object-fit: contain;
    }

    @media ${device.sm} {
        svg {
            width: 3.5rem;
        }
    }
`;

const SidebarQuestsSep = styled.div`
    /* margin: 1rem 4rem; */
    height: 2px;
    width:  ${p => p.expand ? "calc(100% - 8rem)" : "calc(100% - 4rem)"}   ;
    background: ${p => p.theme.mid};
        /* width: calc(100% - 4rem); */
        margin: ${p=> p.expand ? "1rem 4rem" : "1rem 2rem"};
    @media ${device.sm} {
        width: calc(100% - 4rem);
        margin: 1rem 2rem;
    }
`

const CallsBadge = styled.span`
    min-width: 2rem;
    height: 2rem;
    margin-left: auto;
    padding: 0 0.55rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    background: ${(p) => p.overdue ? "#c95252" : "var(--main)"};
    color: var(--white);
    font-size: 1.1rem;
    font-weight: 700;

    ${(p) => !p.expand ? `
        position: absolute;
        top: 0;
        right: 0.2rem;
    ` : ""}
`

const CallsFeatureCoachmark = styled.aside`
    position: fixed;
    top: ${p => p.top}px;
    left: ${p => p.left}px;
    z-index: 9999;
    width: min(30rem, calc(100vw - ${p => p.left + 20}px));
    padding: 1.5rem;
    border: 1px solid ${p => p.theme.mid};
    border-radius: var(--normalRadius);
    background: ${p => p.theme.background};
    color: ${p => p.theme.color};
    box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.2);

    &::before {
        content: "";
        position: absolute;
        left: -0.7rem;
        top: 2rem;
        width: 1.2rem;
        height: 1.2rem;
        transform: rotate(45deg);
        border-left: 1px solid ${p => p.theme.mid};
        border-bottom: 1px solid ${p => p.theme.mid};
        background: ${p => p.theme.background};
    }

    h4 {
        margin: 0.8rem 0 0.5rem;
        font-size: 1.6rem;
    }

    p {
        margin: 0 0 1.5rem;
        color: var(--greyDark);
        line-height: 1.5;
    }

    @media ${device.sm} {
        top: auto;
        right: 2rem;
        bottom: 2rem;
        left: 2rem;
        width: auto;

        &::before {
            display: none;
        }
    }
`

const CoachmarkTop = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
`

const CoachmarkClose = styled.button`
    border: 0;
    padding: 0.25rem;
    background: transparent;
    color: inherit;
    cursor: pointer;

    svg {
        width: 1.4rem;
        fill: currentColor;
    }
`

const CoachmarkAction = styled.button`
    border: 0;
    border-radius: 999px;
    padding: 0.8rem 1.4rem;
    background: var(--main);
    color: var(--white);
    font-family: "fontBold";
    cursor: pointer;
`

export default function Sidebar_Quests(props) {
    const { t } = useTranslation();
    const currentUser = useSelector(state => state.user?.user);
    const navigate = useNavigate();
    const { lang, questId } = useParams();
    const location = useLocation();
    const { quests, archivedQuests } = useCRMContext();
    const expand = props.sidebar ?? true;
    const [tooltip, setTooltip] = useState(null);
    const [showAllArchived, setShowAllArchived] = useState(false);
    const [callSummary, setCallSummary] = useState({ overdue: 0, today: 0 });
    const [showCallsFeature, setShowCallsFeature] = useState(false);
    const [callsFeaturePosition, setCallsFeaturePosition] = useState(null);
    const callsItemRef = useRef(null);

    function getQuestName(quest) {

        let nameFromQuestionnaires = `${quest?.questionnaires?.[0]?.answer || ''} ${quest?.questionnaires?.[1]?.answer || ''} | ${quest?.Meta?.facebookPageName || ''}`;
        //let nameFromQuestionnaires = 'Smart Strategies for Building Confidence, Boosting Productivity, and Achieving Success Every Single Day'
        return quest?.name?  `${LimitCharacters(quest?.name, 55)}`:
            `${LimitCharacters(nameFromQuestionnaires, 55)}`;
    }

    function getAdImageUrl(quest){
        if (quest.adInfo?.thumbnail && quest.adInfo?.thumbnail !== 'default.jpg') {
            return quest?.adInfo?.thumbnail;
        }
        else if (quest?.adInfo?.visualElement) {
            return `${minioImgUrl}/${quest?.userId}/${quest?.adInfo?.visualElement}`;
        }
        else return NoImg;
    };

    const routeLanguage = typeof lang === "string" && lang.trim().length ? lang.trim() : "en";
    const open_integrations = (selection) => {
        try {
            open_email_marketing(selection, routeLanguage);
        } catch {
            navigate(`/${routeLanguage}/crm/integrations/${selection}`);
        }
    };
    const isIntegrations = location.pathname.includes('/crm/integrations');
    const isExport = location.pathname.includes('/crm/export');
    const isCalls = location.pathname.includes('/crm/calls');
    const dueCallCount = Number(callSummary.overdue || 0) + Number(callSummary.today || 0);
    const MAX_ARCHIVED = 5;
    const visibleArchivedQuests = showAllArchived
        ? archivedQuests
        : archivedQuests?.slice(0, MAX_ARCHIVED);
    const websiteBoards = (quests || []).filter((quest) => quest.isWebsiteBoard);
    const standaloneBoards = (quests || []).filter((quest) => quest.isStandaloneBoard);
    const adQuests = (quests || []).filter((quest) => !quest.isWebsiteBoard && !quest.isStandaloneBoard);

    const showTooltip = (event, text) => {
        const rect = event.currentTarget.getBoundingClientRect();
        setTooltip({
            text,
            top: rect.top + rect.height / 2,
            left: rect.right + 12
        });
    };

    const hideTooltip = () => {
        setTooltip(null);
    };

    const callsFeatureStorageKey = currentUser?.sub || currentUser?.email
        ? `crm_calls_feature_seen_v2:${currentUser?.sub || currentUser?.email}`
        : null;

    const dismissCallsFeature = () => {
        setShowCallsFeature(false);
        if (!callsFeatureStorageKey) return;
        try {
            localStorage.setItem(callsFeatureStorageKey, "1");
        } catch (error) {
            // Dismissal still works when browser storage is unavailable.
        }
    };

    const openCalls = () => {
        dismissCallsFeature();
        navigate(`/${routeLanguage}/crm/calls`);
    };

    useEffect(() => {
        if (!callsFeatureStorageKey) return;

        try {
            if (localStorage.getItem(callsFeatureStorageKey)) return;
        } catch (error) {
            // The coachmark still works when browser storage is unavailable.
        }
        setShowCallsFeature(true);
    }, [callsFeatureStorageKey]);

    useEffect(() => {
        if (!showCallsFeature) return undefined;

        const positionCoachmark = () => {
            const rect = callsItemRef.current?.getBoundingClientRect();
            if (!rect) return;
            setCallsFeaturePosition({ top: rect.top - 8, left: rect.right + 12 });
        };

        positionCoachmark();
        window.addEventListener("resize", positionCoachmark);
        window.addEventListener("scroll", positionCoachmark, true);
        return () => {
            window.removeEventListener("resize", positionCoachmark);
            window.removeEventListener("scroll", positionCoachmark, true);
        };
    }, [showCallsFeature, expand]);

    useEffect(() => {
        let mounted = true;

        b.getUserCalls({ limit: 1 }).then((response) => {
            if (!mounted || !response) return;
            setCallSummary(response?.data?.summary || { overdue: 0, today: 0 });
        });

        return () => { mounted = false; };
    }, [location.pathname]);

    return (
        <SidebarQuests sidebar={props.sidebar}>
            <h6>{(props.generalTitle || t("General")).toUpperCase()}</h6>
            <SidebarQuestsList>
                <SidebarQuestsItem
                    active={!questId && !isExport && !isCalls && !isIntegrations}
                    expand={expand}
                    onMouseEnter={(e) => {
                        if (!expand) {
                            showTooltip(e, t("Boards"));
                        }
                    }}
                    onMouseLeave={hideTooltip}
                    onClick={() => navigate(`/${routeLanguage}/crm`)}
                >
                    <IconSvg Icon="Workspace" />
                    {expand && <h5>{t("Boards")}</h5>}
                </SidebarQuestsItem>
                <SidebarQuestsItem
                    ref={callsItemRef}
                    active={isCalls}
                    expand={expand}
                    onMouseEnter={(e) => {
                        if (!expand) {
                            showTooltip(e, t("Calls"));
                        }
                    }}
                    onMouseLeave={hideTooltip}
                    onClick={openCalls}
                >
                    <IconSvg Icon="Phone" />
                    {expand && <h5>{t("Calls")}</h5>}
                    {dueCallCount > 0 ? (
                        <CallsBadge expand={expand} overdue={callSummary.overdue > 0}>
                            {dueCallCount > 99 ? "99+" : dueCallCount}
                        </CallsBadge>
                    ) : null}
                </SidebarQuestsItem>
                <SidebarQuestsItem
                    active={isExport}
                    expand={expand}
                    onMouseEnter={(e) => {
                        if (!expand) {
                            showTooltip(e, t("Export data"));
                        }
                    }}
                    onMouseLeave={hideTooltip}
                    onClick={() => navigate(`/${routeLanguage}/crm/export`)}
                >
                    <IconSvg Icon="Download" />
                    {expand && <h5>{t("Export data")}</h5>}
                </SidebarQuestsItem>
            </SidebarQuestsList>
            <SidebarQuestsSep />
            <h6>{t("Integrations").toUpperCase()}</h6>
            <SidebarQuestsList>
                <SidebarIntegrationItem
                    expand={expand}
                    role="link"
                    tabIndex={0}
                    aria-label={t("Doitforme CRM Forms")}
                    onKeyDown={event => {
                        if (event.key === "Enter") {
                            event.preventDefault();
                            open_integrations('doitforme-crm-forms');
                        }
                    }}
                    onMouseEnter={event => {
                        if (!expand) {
                            showTooltip(event, t("Doitforme CRM Forms"));
                        }
                    }}
                    onMouseLeave={hideTooltip}
                    onClick={() => open_integrations('doitforme-crm-forms')}
                >
                    <IntegrationsIcon aria-hidden="true" focusable="false" />
                    {expand && <h5>{t("Doitforme CRM Forms")}</h5>}
                </SidebarIntegrationItem>
                <SidebarIntegrationItem
                    expand={expand}
                    role="link"
                    tabIndex={0}
                    aria-label={t("SendPulse CRM")}
                    onKeyDown={event => {
                        if (event.key === "Enter") {
                            event.preventDefault();
                            open_integrations('sendpulse');
                        }
                    }}
                    onMouseEnter={event => {
                        if (!expand) {
                            showTooltip(event, t("SendPulse CRM"));
                        }
                    }}
                    onMouseLeave={hideTooltip}
                    onClick={() => open_integrations('sendpulse')}
                >
                    <img
                        src="https://genius1071.friktoriaservers.net/doitforme/icons/sendpulse.png"
                        alt=""
                    />
                    {expand && <h5>{t("SendPulse CRM")}</h5>}
                </SidebarIntegrationItem>
                <SidebarIntegrationItem
                    expand={expand}
                    role="link"
                    tabIndex={0}
                    aria-label={t("Mailchimp")}
                    onKeyDown={event => {
                        if (event.key === "Enter") {
                            event.preventDefault();
                            open_integrations('mailchimp');
                        }
                    }}
                    onMouseEnter={event => {
                        if (!expand) {
                            showTooltip(event, t("Mailchimp"));
                        }
                    }}
                    onMouseLeave={hideTooltip}
                    onClick={() => open_integrations('mailchimp')}
                >
                    <img
                        src="https://genius1071.friktoriaservers.net/doitforme/icons/mailchimp.png"
                        alt=""
                    />
                    {expand && <h5>{t("Mailchimp")}</h5>}
                </SidebarIntegrationItem>
                <SidebarIntegrationItem
                    expand={expand}
                    role="link"
                    tabIndex={0}
                    aria-label={t("Pipedrive CRM")}
                    onKeyDown={event => {
                        if (event.key === "Enter") {
                            event.preventDefault();
                            open_integrations('pipedrive');
                        }
                    }}
                    onMouseEnter={event => {
                        if (!expand) {
                            showTooltip(event, t("Pipedrive CRM"));
                        }
                    }}
                    onMouseLeave={hideTooltip}
                    onClick={() => open_integrations('pipedrive')}
                >
                    <img
                        src="https://genius1071.friktoriaservers.net/doitforme/icons/pipedrive.png"
                        alt=""
                    />
                    {expand && <h5>{t("Pipedrive CRM")}</h5>}
                </SidebarIntegrationItem>
                <SidebarIntegrationItem
                    expand={expand}
                    role="link"
                    tabIndex={0}
                    aria-label={t("Brevo")}
                    onKeyDown={event => {
                        if (event.key === "Enter") {
                            event.preventDefault();
                            open_integrations('brevo');
                        }
                    }}
                    onMouseEnter={event => {
                        if (!expand) {
                            showTooltip(event, t("Brevo"));
                        }
                    }}
                    onMouseLeave={hideTooltip}
                    onClick={() => open_integrations('brevo')}
                >
                    <img
                        src="https://genius1071.friktoriaservers.net/doitforme/icons/brevo.png"
                        alt=""
                    />
                    {expand && <h5>{t("Brevo")}</h5>}
                </SidebarIntegrationItem>
                <SidebarIntegrationItem
                    expand={expand}
                    role="link"
                    tabIndex={0}
                    aria-label={t("API Access")}
                    onKeyDown={event => {
                        if (event.key === "Enter") {
                            event.preventDefault();
                            open_integrations('api-access');
                        }
                    }}
                    onMouseEnter={event => {
                        if (!expand) showTooltip(event, t("API Access"));
                    }}
                    onMouseLeave={hideTooltip}
                    onClick={() => open_integrations('api-access')}
                >
                    <IntegrationsIcon aria-hidden="true" focusable="false" />
                    {expand && <h5>{t("API Access")}</h5>}
                </SidebarIntegrationItem>
            </SidebarQuestsList>
            <SidebarQuestsSep></SidebarQuestsSep>
            {websiteBoards.length > 0 ? (
                <>
                    <h6>{t('Website leads').toUpperCase()}</h6>
                    <SidebarQuestsList>
                        {websiteBoards.map((board) => (
                            <SidebarQuestsItem
                                key={board._id}
                                active={String(questId) === String(board._id)}
                                expand={expand}
                                onClick={() => navigate(`/${routeLanguage}/crm/board/${board._id}`)}
                            >
                                <img src={getBoardAvatarSrc(board)} alt={board.name || t('Website Leads')} />
                                {expand && <h5>{t(board.name || 'Website Leads')}</h5>}
                            </SidebarQuestsItem>
                        ))}
                    </SidebarQuestsList>
                    <SidebarQuestsSep></SidebarQuestsSep>
                </>
            ) : null}
            {standaloneBoards.length > 0 ? <>
                <h6>{t('CRM boards').toUpperCase()}</h6>
                <SidebarQuestsList>
                    {standaloneBoards.map(board => (
                        <SidebarQuestsItem
                            key={board._id}
                            active={String(questId) === String(board._id)}
                            expand={expand}
                            role="link"
                            tabIndex={0}
                            aria-label={board.name}
                            onMouseEnter={event => { if (!expand) showTooltip(event, board.name); }}
                            onMouseLeave={hideTooltip}
                            onKeyDown={event => { if (event.key === 'Enter') navigate(`/${routeLanguage}/crm/board/${board._id}`); }}
                            onClick={() => navigate(`/${routeLanguage}/crm/board/${board._id}`)}
                        >
                            <img src={getBoardAvatarSrc(board)} alt={board.name} />
                            {expand && <h5>{board.name}</h5>}
                        </SidebarQuestsItem>
                    ))}
                </SidebarQuestsList>
                <SidebarQuestsSep />
            </> : null}
            {adQuests.length > 0 && <h6>{(props.questsTitle || t("Active Quests")).toUpperCase()}</h6>}
            <SidebarQuestsList>
                {adQuests.map((quest, i) => (
                    <SidebarQuestsItem
                        value={quest._id}
                        key={quest?._id || i}
                        active={String(questId) === String(quest._id)}
                        expand={expand}
                        onMouseEnter={(e) => {
                            if (!expand) {
                                showTooltip(e, getQuestName(quest));
                            }
                        }}
                        onMouseLeave={hideTooltip}
                        onClick={() => navigate(`/${routeLanguage}/crm/board/${quest._id}`)}
                    >
                        <img src={getAdImageUrl(quest)} alt="Ad" />
                        {expand && <h5>{getQuestName(quest)}</h5>}
                    </SidebarQuestsItem>
                ))}
            </SidebarQuestsList>
            {visibleArchivedQuests?.length > 0 && <>
                <SidebarQuestsSep></SidebarQuestsSep>
                <h6>{(props.archivedQuestsTitle || t("Archived Quests")).toUpperCase()}</h6>
            </>}
            <SidebarQuestsList>
                {visibleArchivedQuests?.map((quest, i) => (
                    <SidebarQuestsItem
                        value={quest._id}
                        key={quest?._id || `archived-${i}`}
                        active={String(questId) === String(quest._id)}
                        expand={expand}
                        onMouseEnter={(e) => {
                            if (!expand) {
                                showTooltip(e, getQuestName(quest));
                            }
                        }}
                        onMouseLeave={hideTooltip}
                        onClick={() => navigate(`/${routeLanguage}/crm/board/${quest._id}`)}
                    >
                        <img src={getAdImageUrl(quest)} alt="Ad" />
                        {expand && <h5>{getQuestName(quest)}</h5>}
                    </SidebarQuestsItem>
                ))}
            </SidebarQuestsList>
            {archivedQuests?.length > MAX_ARCHIVED && (
                <Main_Plain
                    text={showAllArchived ? t("Show less") : t("View all")}
                    onClick={() => setShowAllArchived(prev => !prev)}
                    size='small'
                    iconRIght
                />
            )}
            {!expand && tooltip && createPortal(
                <TooltipPortal style={{ top: tooltip.top, left: tooltip.left }}>
                    {tooltip.text}
                </TooltipPortal>,
                document.body
            )}
            {showCallsFeature && callsFeaturePosition && createPortal(
                <CallsFeatureCoachmark
                    role="status"
                    top={callsFeaturePosition.top}
                    left={callsFeaturePosition.left}
                >
                    <CoachmarkTop>
                        <CoachmarkClose
                            type="button"
                            aria-label={t("Dismiss")}
                            onClick={dismissCallsFeature}
                        >
                            <IconSvg Icon="Xicon" />
                        </CoachmarkClose>
                    </CoachmarkTop>
                    <h4>{t("All your calls in one place")}</h4>
                    <p>{t("See upcoming and overdue calls from every CRM board.")}</p>
                    <CoachmarkAction type="button" onClick={openCalls}>
                        {t("View calls")}
                    </CoachmarkAction>
                </CallsFeatureCoachmark>,
                document.body
            )}
        </SidebarQuests>
    )
}
